import { RuntimeAction, SPI, ActionWidget, ActionWidgetProps, Widget, http, CallChaining } from '@kunlun/dependencies';
import Comp from './ActivityAddBtn.vue';
import { cloneDeep } from 'lodash-es';

@SPI.ClassFactory(ActionWidget.Token({ name: ['ActivityAddBtnAction'] }))
export class ActivityAddBtnAction extends ActionWidget {
  public initialize(props: ActionWidgetProps<RuntimeAction>) {
    super.initialize(props);
    this.setComponent(Comp);
    return this;
  }

  @Widget.Reactive()
  private queryRemote = true;

  private prevRootData: any = {};
  private mountedFlag = false;

  @Widget.Reactive()
  @Widget.Inject()
  protected mountedCallChaining: CallChaining | undefined;

  protected mounted() {
    super.mounted();
    if (this.mountedCallChaining) {
      this.mountedCallChaining.hook(this.path, async () => {
        await this.mountedProcess();
      });
    } else {
      this.mountedProcess();
    }
  }

  protected mountedProcess(): void {
    this.prevRootData = cloneDeep(this.rootData);
    this.mountedFlag = true;
  }

  @Widget.Watch('rootData', { deep: true, immediate: true })
  private watchRootData(rootData) {
    const val = rootData?.[0]?.suitDistributorScope;
    this.queryRemote = !val || val === 'ALL_DISTRIBUTOR' || val === 'CHANNEL_TYPE';

    if (rootData?.length && this.mountedFlag) {
      const { suitDistributorScope, creditSettlementMethod, specialDistributorScope } = rootData[0];
      if (
        suitDistributorScope !== this.prevRootData?.[0]?.suitDistributorScope ||
        creditSettlementMethod !== this.prevRootData?.[0]?.creditSettlementMethod ||
        specialDistributorScope !== this.prevRootData?.[0]?.specialDistributorScope
      ) {
        this.reloadDataSource([]);
        this.prevRootData = cloneDeep(rootData);
      }
    }
  }

  @Widget.Method()
  private getPropKeyName() {
    return this.model.model === 'deli.aries.promotion.DeliAriesCompanyPlanProxy'
      ? 'platformSuitDistributors'
      : 'suitDistributors';
  }

  @Widget.Method()
  async getTableDataRemote(params: {
    currentPage: number;
    size: number;
    targetPartnerCode: string;
    targetPartnerName: string;
    customerErpCode: string;
  }) {
    const key = this.getPropKeyName();
    if (key === 'suitDistributors') {
      const gql = `
        mutation {
          promotionPartnerRelationMutation {
            queryActPartnerPage(
              page: { 
                currentPage: ${params.currentPage}, 
                size: ${params.size}
              }
              queryWrapper: {
                rsql: "(1==1) and (1==1)", 
                queryData: {
                  targetPartnerCode: "${params.targetPartnerCode}", 
                  targetPartnerName: "${params.targetPartnerName}", 
                  customerErpCode: "${params.customerErpCode}"
                }
              }
            ) {
              content {
                targetPartnerCode
                targetPartnerName
                customerErpCode
                id
                targetPartner {
                  name
                }
              }
              totalPages
              totalElements
            }
          }
        }
      `;
      const res = await http.query(this.model.moduleName, gql);

      return res.data.promotionPartnerRelationMutation?.queryActPartnerPage ?? {};
    }
    if (key === 'platformSuitDistributors') {
      const gql = `
        query {
          deliAriesCompanyPlanProxyQuery {
            queryPage(
              page: {
                currentPage: ${params.currentPage}, 
                size: ${params.size}
              }
              queryWrapper: {
                rsql: "(1==1)${params.targetPartnerCode ? ` and (code=like='${params.targetPartnerCode}')` : ''}${
        params.targetPartnerName ? ` and (name=like='${params.targetPartnerName}')` : ''
      }", 
                queryData: {
                  code: "${params.targetPartnerCode}", 
                  name: "${params.targetPartnerName}"
                }
              }
            ) {
              content {
                code
                name
                erpCode
                id
              }
              totalPages
              totalElements
            }
          }
        }
      `;
      const res = await http.query(this.model.moduleName, gql);
      const resData: Record<any, any> = res.data?.deliAriesCompanyPlanProxyQuery?.queryPage ?? {};
      resData.content?.forEach((i) => {
        i.targetPartnerCode = i.code;
        i.customerErpCode = i.erpCode || '';
        i.targetPartnerName = i.name;
      });
      return resData;
    }
  }

  @Widget.Method()
  getTableData() {
    const key = this.getPropKeyName();
    const data = (this.rootData?.[0]?.[key] ?? []) as any[];

    if (data.length && !data[0].targetPartnerCode) {
      data.forEach((i) => {
        i.targetPartnerCode = i.code;
        i.customerErpCode = i.erpCode || '';
        i.targetPartnerName = i.name;
      });
    }

    return data;
  }

  @Widget.Method()
  setRootTableData(data) {
    const newArr = [...data, ...(this.dataSource || [])];
    const uniqueArr: any[] = [];
    const uniqueMap: any = {};
    // 去重
    newArr.forEach((i, index) => {
      i._sortIndex = index;
      uniqueMap[i.targetPartnerCode] = i;
    });
    // 转数组
    for (let k in uniqueMap) {
      uniqueArr.push(uniqueMap[k]);
    }
    // 排序
    uniqueArr.sort((a, b) => a._sortIndex - b._sortIndex);

    this.reloadDataSource(uniqueArr);
  }
}
